import styled from 'styled-components';

export const SecondaryInfoText = styled.span`
  color: ${(props) => props.theme.colors.purple};
  display: inline-block;
  margin-left: 5px;
  font-size: 12px;
`;
